import { render } from "./SkinProfile.vue?vue&type=template&id=91cf5d30&scoped=true&bindings={}"
import script from "./SkinProfile.vue?vue&type=script&lang=ts"
export * from "./SkinProfile.vue?vue&type=script&lang=ts"

import "./SkinProfile.vue?vue&type=style&index=0&id=91cf5d30&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-91cf5d30"

export default script